import { render } from "./main.vue?vue&type=template&id=4094385c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=4094385c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4094385c"],['__file',"src/views/wap/main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4094385c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4094385c', __exports__)) {
    console.log('reload')
    api.reload('4094385c', __exports__)
  }
  
  module.hot.accept("./main.vue?vue&type=template&id=4094385c&scoped=true", () => {
    console.log('re-render')
    api.rerender('4094385c', render)
  })

}


export default __exports__